import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Select, Button, Table, Tooltip } from 'antd'
import {ArrowDownOutlined, ArrowUpOutlined, DeleteOutlined, QuestionCircleFilled} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const {TextArea} = Input
@inject('marketingResourcePoolStore')
@observer
class FormModal extends Component {
  state = {
    isLock: false,
    analysisLoading: false,
    canAdd: true,
    config: []
  }

  formRef = React.createRef()

  componentDidMount() {
    const {marketingResourcePoolStore, title} = this.props
    const {detailsObj} = marketingResourcePoolStore
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        "resourcePoolName": detailsObj?.resourcePoolName,
        "marketingGroupId": detailsObj?.marketingGroupId ? JSON.parse(JSON.stringify(detailsObj?.marketingGroupId)) : [],
        "marketingType": detailsObj?.marketingType ? JSON.parse(JSON.stringify(detailsObj?.marketingType)) : [],
        "sqlScript": detailsObj?.sqlScript,
        "conditions": detailsObj?.conditions ? JSON.parse(JSON.stringify(detailsObj?.conditions)) : [],
      })
      this.setState({
      })
      this.analysisSql()
    } else {
    }
  }

  handleOk = () => {
    const {marketingResourcePoolStore, handleCancel, title} = this.props
    const {detailsObj} = marketingResourcePoolStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        "id": title === 'edit' ? detailsObj?.id : null,
        "resourcePoolName": fieldsValue?.resourcePoolName,
        "marketingGroupId": fieldsValue?.marketingGroupId,
        "marketingType": fieldsValue?.marketingType,
        "sqlScript": fieldsValue?.sqlScript,
        "conditions": fieldsValue?.conditions,
      }
      if (title === 'edit') {
        marketingResourcePoolStore.onAddJobAction({...params, id: detailsObj.id}, title).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      } else {
        marketingResourcePoolStore.onAddJobAction({...params}).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      }
    }).catch(() => {})
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  handleUnlock = () => {
    let _this = this
    _this.setState({isLock: false, canAdd: true})
  }
  analysisSql = () => {
    this.setState({analysisLoading: true})
    const {marketingResourcePoolStore} = this.props
    const {current} = this.formRef
    const sql = current.getFieldValue('sqlScript') 
    const sqlSelect = [...current.getFieldValue('conditions')]

    marketingResourcePoolStore.analysisReportSql({sql, sqlSelect}).then(res => {
      if (res.code === 0) {
        // current.setFieldsValue({conditions: res.data.sqlSelect})
        this.setState({isLock: true, canAdd: false})
      }
      this.setState({analysisLoading: false})
    }).catch(() => {
      this.setState({analysisLoading: false})
    })
  }
  onConditionNameChange = (index, e) => {
    const {marketingResourcePoolStore} = this.props
    const {reportSqlList} = marketingResourcePoolStore
    const {current} = this.formRef
    const tempArr = [...current.getFieldValue('conditions')]

    tempArr[index].type = reportSqlList.filter(item => item.name === e)[0]?.type
    current.setFieldsValue({
      'conditions': tempArr
    })
  }
  render() {
    const { marketingResourcePoolStore, addModalVisible, handleCancel, title, t } = this.props
    const { groupList, statusList, reportConditionOperatorList, reportSqlList, typeList } = marketingResourcePoolStore
    const {isLock, analysisLoading, canAdd} = this.state
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`marketingManagement.editResourcePool`) : t(`marketingManagement.addResourcePool`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'60%'}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} disabled={!isLock} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col span={8}>
                <Form.Item name="resourcePoolName" label={t(`marketingManagement.resourcePoolName`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.resourcePoolName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\]*$/)
                }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="marketingGroupId" 
                  label={(<><span style={{display: 'inline-block', paddingRight: 5}}>{t(`marketingManagement.marketingGroup`)}</span> <Tooltip title={t('marketingManagement.groups')}><QuestionCircleFilled /></Tooltip></>)}
                  rules={[{required: false, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.marketingGroup`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch showArrow mode="multiple" maxTagCount="responsive" maxTagTextLength={10} filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                    {groupList?.map((item, i) => (<Select.Option key={i} value={item?.id}>{item?.groupName}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="marketingType" label={t(`marketingManagement.marketingClass`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.marketingClass`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch showArrow mode="multiple" maxTagCount="responsive" maxTagTextLength={10} filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                    {statusList?.map((item, i) => (<Select.Option key={i} value={item?.code}>{item?.name}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                <Form.Item name="sqlScript" label={t(`marketingManagement.permissionStatement`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)}${t(`marketingManagement.permissionStatement`)}`,
                }]}>
                  <TextArea disabled={isLock} rows={8} placeholder={t(`general.pleaseEnter`)} allowClear/>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Row>
                  <Form.List name="conditions" initialValue={[]}>
                    {(fields, {add, remove, move}) => (
                      <>
                        <Col span={12}>
                          <span style={{ color: '#ff4d4f', fontSize: '14px', marginRight: '4px', fontFamily: 'SimSun, sans-serif', fontWeight: 'normal' }}>*</span>
                          {t(`marketingManagement.resourcePoolConfig`)}
                        </Col>
                        <Col span={12} style={{textAlign: 'right'}}>
                          <Button key="unlock" style={{marginRight: '10px'}} onClick={this.handleUnlock}
                                  disabled={!isLock}>{t(`reportManagement.unlock`)}</Button>
                          <Button key="analysis" style={{marginRight: '10px'}} loading={analysisLoading}
                                  onClick={this.analysisSql} disabled={isLock}>{t(`reportManagement.analysis`)}</Button>
                          <Button
                            key="add"
                            disabled={canAdd}
                            type='danger'
                            onClick={() => { add() }}>{t(`reportManagement.conditionAdd`)}
                          </Button>
                        </Col>
                        <Col span={24}>
                          <Table
                            dataSource={fields}
                            pagination={false}
                            style={{margin: '10px 0'}}
                            // loading={analysisLoading}
                          >
                            <Table.Column
                              title={t(`marketingManagement.title`)}
                              dataIndex="name"
                              key="name"
                              render={(text, row) => {
                                return (
                                  <Form.Item
                                    name={[row?.name, 'name']}
                                    rules={[{
                                      required: true,
                                      message: `${t(`general.pleaseSelect`)}${t(`reportManagement.conditionName`)}`,
                                    }]}>
                                    <Select
                                      placeholder={t(`general.pleaseSelect`)}
                                      allowClear
                                      onChange={(e) => this.onConditionNameChange(row?.name, e)}
                                    >
                                      {
                                        reportSqlList.length > 0
                                          ? reportSqlList.map((item, i) => (
                                            <Select.Option key={i} value={item?.name}>{item?.name}</Select.Option>
                                          ))
                                          : null
                                      }
                                    </Select>
                                  </Form.Item>
                                )
                              }}
                            />
                            <Table.Column
                              title={t(`marketingManagement.showType`)}
                              dataIndex="configType"
                              key="configType"
                              render={(text, row) => {
                                return (
                                  <Form.Item name={[row?.name, 'configType']}>
                                    <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                                      {
                                        typeList.length > 0
                                          ? typeList?.map((item, i) => <Select.Option key={i} value={item?.code}>{item?.name}</Select.Option>)
                                          : null
                                      }
                                    </Select>
                                  </Form.Item>
                                )
                              }} />
                            <Table.Column
                              title={t(`marketingManagement.ifElse`)}
                              dataIndex="operator"
                              key="operator"
                              render={(text, row) => {
                                return (
                                  <Form.Item
                                    name={[row?.name, 'operator']}
                                    rules={[{
                                      required: true,
                                      message: `${t(`general.pleaseSelect`)}${t(`reportManagement.conditionOperator`)}`,
                                    }]}>
                                    <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                                      {
                                        reportConditionOperatorList.length > 0
                                          ? reportConditionOperatorList?.map((item, i) => <Select.Option key={i} value={item}>{item}</Select.Option>)
                                          : null
                                      }
                                    </Select>
                                  </Form.Item>
                                )
                              }}
                            />
                            <Table.Column
                              title={t(`reportManagement.conditionType`)}
                              dataIndex="type"
                              key="type"
                              render={(text, row) => {
                                return (
                                  <Form.Item name={[row.name, 'type']}>
                                    {this.formRef.current.getFieldValue(['conditions', row.name, 'type'])}
                                  </Form.Item>
                                )
                              }} />
                            <Table.Column align="center" title={t(`general.action`)} key="Action" render={(text, row, index) => (<>
                              <Button type="link" onClick={() => remove(index)} icon={<DeleteOutlined />} title={t(`general.delete`)} />
                              {index !== 0 && (
                                <Button type="link" onClick={() => move(index, index - 1)} icon={<ArrowUpOutlined />} title={t(`general.delete`)} />)}
                              {fields.length !== index + 1 && (
                                <Button type="link" onClick={() => move(index, index + 1)} icon={<ArrowDownOutlined />} title={t(`general.delete`)} />)}
                            </>
                            )} />
                          </Table>
                        </Col>
                      </>
                    )}
                  </Form.List>
                </Row>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
